import { render, staticRenderFns } from "./BookingDialogStepProduct.vue?vue&type=template&id=621b2669&scoped=true&"
import script from "./BookingDialogStepProduct.vue?vue&type=script&lang=js&"
export * from "./BookingDialogStepProduct.vue?vue&type=script&lang=js&"
import style0 from "./BookingDialogStepProduct.vue?vue&type=style&index=0&id=621b2669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621b2669",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorsProduct: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/ColorsProduct.vue').default})
